module.exports = "<app-maintainwarehousetransfer></app-maintainwarehousetransfer>\n<app-print-warehousetransfer></app-print-warehousetransfer>"